var map = {
	"./logo1.png": 3660,
	"./logo2.png": 4343,
	"./logo3.jpeg": 9271,
	"./logo4.png": 3121,
	"./logo5.png": 4728,
	"./logo6.png": 3059,
	"./logo7.png": 6874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1712;